import { environment } from "../../environments/environment";

declare var amf: any;

export class AmfAbstractService {

  protected _amf: any;

  constructor(destination: string) {
    this._amf = new amf.Client(destination, environment.urlAmf);
  }

}
